export const dashboardPath = () => "/dashboard";
